import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tooltip-container" }
const _hoisted_2 = { class: "tooltip-container__element" }
const _hoisted_3 = {
  key: 0,
  class: "tooltip-container__arrow-up"
}
const _hoisted_4 = {
  key: 1,
  class: "tooltip-container__arrow-down"
}
const _hoisted_5 = { class: "tooltip-container__content" }
const _hoisted_6 = { class: "tooltip-container__footer" }

import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvancedTooltip',
  setup(__props) {

const isUp = ref(false);
const fromTop = ref(50);
const advancedTooltip = ref<HTMLElement | null>(null);

onMounted(() => {
  if (advancedTooltip.value) {
    const position = advancedTooltip.value.getBoundingClientRect();
    const padding = 15;
    if (position.bottom > window.innerHeight - padding) {
      isUp.value = true;
      fromTop.value = -(position.height + padding);
      return;
    }
  }
  isUp.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "element")
    ]),
    _createElementVNode("div", {
      ref_key: "advancedTooltip",
      ref: advancedTooltip,
      class: _normalizeClass(["tooltip-container__tooltip", { 'is-up': isUp.value }]),
      style: _normalizeStyle({ top: `${fromTop.value}px` })
    }, [
      (!isUp.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (isUp.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "content")
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "footer")
      ])
    ], 6)
  ]))
}
}

})